export default __webpack_public_path__ + "static/media/General_Electric.6f5c1cce.png";